import { Injectable } from '@angular/core';
import { AssetsApiService } from '@api/assets/assets.api.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ActionResponse, AssetDataResult, AssetInErrorDataResult } from '../../types/DataResult';

@Injectable()
export class AssetsRepositoryService {
  public constructor(private readonly assetsApi: AssetsApiService) {}

  public getAssets(params: {
    Limit?: number;
    Search?: string;
    Skip?: number;
    OnlyRecordCount?: boolean;
    WithSite?: boolean;
    WithSiteArea?: boolean;
    DynamicOnly?: boolean;
    Issuer?: boolean;
    SiteAreaID?: string[];
    SiteID?: string[];
    AssetID?: string;
  }): Observable<AssetDataResult> {
    return this.assetsApi.getAssets(params);
  }

  public getAssetsInError(params: {
    Limit?: number;
    Search?: string;
    Skip?: number;
    OnlyRecordCount?: boolean;
    WithSite?: boolean;
    WithSiteArea?: boolean;
    Issuer?: boolean;
    SiteAreaID?: string[];
    SiteID?: string[];
    ErrorType?: string[];
  }): Observable<AssetInErrorDataResult> {
    return this.assetsApi.getAssetsInError(params);
  }

  public tableRetrieveAssetConsumptionAction(id: string): Observable<ActionResponse> {
    return this.assetsApi.tableRetrieveAssetConsumptionAction(id);
  }

  public deleteAsset(id: string): Observable<ActionResponse> {
    return this.assetsApi.deleteAsset(id);
  }

  public siteAreaContainsAssets(siteAreaID: string): Observable<boolean> {
    return this.getAssets({ SiteAreaID: [siteAreaID] }).pipe(
      map((assetsDataResult) => assetsDataResult.count > 0),
      catchError(() => of(false)),
    );
  }
}
